import { Box, Button } from '@superdispatch/ui-lab';
import { Stack } from '@superdispatch/ui';
import { Typography } from '@material-ui/core';
import { CheckIcon } from 'shared/icons/CheckIcon';
import styled from 'styled-components';

const CustomCheckIcon = styled(CheckIcon)`
  width: 88px;
  height: 88px;
`;

export function InstantTransferSettleCompleted({
  onClose,
  loadID,
}: {
  onClose: () => void;
  loadID?: string;
}) {
  return (
    <Box padding="medium">
      <Stack space="medium" align="center">
        <CustomCheckIcon />
        <Stack>
          <Typography variant="h3" align="center">
            Payment already completed
          </Typography>
          <Typography>
            The payment link for <b>Order {loadID}</b> has expired because the
            payment has been settled. No further action is required.
          </Typography>
        </Stack>
        <Button onClick={onClose}>Got It</Button>
      </Stack>
    </Box>
  );
}
